import React from 'react';
import PropTypes from 'prop-types';

import styles from './textFrame.scss';

const TextFrame = (props) => {
    const {
        className,
        title,
        description,
    } = props;

    return (
        <div className={className}>
            <div className={styles.title}>
                {title}
            </div>
            <div className={styles.description}>
                {description}
            </div>
        </div>
    );
};

TextFrame.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

TextFrame.defaultProps = {
    className: '',
};

export default TextFrame;
